import React from 'react'
import clsx from 'clsx'
import { createUseStyles } from '../../lib/styling'
import { FlexLayout, FlexLayoutProps } from '../internal/FlexLayout'
import { AlignItems, Spacing } from '../helperTypes'

export type StackProps = {
  /** Aligns children horizontally */
  align?: AlignItems
  /** Specifies the gap beween children */
  spacing?: Spacing
} & FlexLayoutProps

const useStyles = createUseStyles(
  (theme: any) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: ({ align }: StackProps) => (align === 'center' ? align : `flex-${align}`),
    },
    child: {
      marginTop: 0,
      marginBottom: ({ spacing }: StackProps) => (spacing ? theme.size.spacing.inset[spacing] : 0),
      '&:last-child': {
        marginBottom: 0,
      },
    },
  }),
  'stack',
)

const Stack = ({ className, childrenClassName, spacing, align, ...rest }: StackProps) => {
  const classes = useStyles({ spacing, align })
  return (
    <FlexLayout
      className={clsx(className, classes.root)}
      childrenClassName={clsx(classes.child, childrenClassName)}
      {...rest}
    />
  )
}

export default Stack
